module.exports = __webpack_public_path__ + "img/money.136360a9.png";